import { Box, Typography } from "@mui/material";
import BillingTable from "src/components/DashboardComponents/BillingTable/BillingTable";

function BillingPage() {
  return (
    <Box sx={{ mt: 1, p: { lg: 1, xs: 2, md: 2, sm: 2 } }}>
      <BillingTable />
    </Box>
  );
}

export default BillingPage;
